import React, { useContext } from "react";
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";

import ListenerContext from "../listener/context";
import { theme } from "../theme";

const ChatOptionForm = ({ handleClose, submitFunction }) => {
    const listener = useContext(ListenerContext);

    const {
        register,
        handleSubmit,
        reset,
    } = useForm();

    return(
        <Form
            onSubmit={handleSubmit((data) => {
                handleClose();
                reset();
                submitFunction(data.job_id, listener.dispatch)
            })}
        >
            <TextField
                label="Enter the job id"
                // variant="standard" 
                size="small"
                type="number"
                {...register("job_id", { required: true })}
                InputProps={{
                    endAdornment: (
                        <InputAdornment
                            position="end"
                        >
                            <IconButton
                                type="submit"
                                edge="end"
                                color={theme.main}
                                style={{ backgroundColor: "transparent" }}
                            >
                                <ArrowForward
                                    sx={{ fontSize: '24px' }}
                                />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Form>
    );
}

export default ChatOptionForm;